/**
 * 轻提示
 *
 * 纪律（通知队列）：同时最多 3 条，2.6 秒自动消失，不阻塞操作。
 * 不用模态框打断孩子 —— 提示是补充信息，不是必须确认的对话框。
 */

type ToastKind = "info" | "ok" | "warn" | "error";

const MAX_VISIBLE = 3;
const DEFAULT_DURATION = 2600;

export function toast(message: string, kind: ToastKind = "info", duration = DEFAULT_DURATION): void {
  const root = document.getElementById("toast-root");
  if (!root) return;

  const element = document.createElement("div");
  element.className = `toast toast--${kind}`;
  element.setAttribute("role", kind === "error" ? "alert" : "status");
  element.textContent = message;
  root.append(element);

  while (root.childElementCount > MAX_VISIBLE) {
    root.firstElementChild?.remove();
  }

  window.setTimeout(() => {
    element.style.transition = "opacity 220ms ease, transform 220ms ease";
    element.style.opacity = "0";
    element.style.transform = "translateY(0.4rem)";
    window.setTimeout(() => element.remove(), 260);
  }, duration);
}
